import { css as m, LitElement as w, html as r, nothing as h } from "lit";
import { query as x, property as p, state as g, customElement as f } from "lit/decorators.js";
import { classMap as v } from "lit/directives/class-map.js";
import { styleMap as b } from "lit/directives/style-map.js";
import { b as k } from "./styles-scZ6dVz-.js";
import { b as c, a as u } from "./events-CkEPl0SM.js";
import { g as y } from "./a11y-DxQW21Jt.js";
var C = Object.defineProperty, M = Object.getOwnPropertyDescriptor, l = (e, t, i, n) => {
  for (var o = n > 1 ? void 0 : n ? M(t, i) : t, a = e.length - 1, d; a >= 0; a--)
    (d = e[a]) && (o = (n ? d(t, i, o) : d(o)) || o);
  return n && o && C(t, i, o), o;
};
let s = class extends w {
  constructor() {
    super(...arguments), this.menuId = y("ark-context-menu"), this.items = [], this.open = !1, this.disabled = !1, this.position = { x: 0, y: 0 }, this.highlightedIndex = -1, this.handleContextMenu = (e) => {
      this.disabled || (e.preventDefault(), this.show(e.clientX, e.clientY));
    }, this.handleOutsideClick = (e) => {
      this.open && !this.menuElement?.contains(e.target) && this.hide();
    }, this.handleOutsideContextMenu = (e) => {
      this.open && !this.contains(e.target) && this.hide();
    }, this.handleKeydown = (e) => {
      if (!this.open) return;
      const t = this.items.filter((i) => !i.divider && !i.disabled);
      switch (e.key) {
        case "Escape":
          e.preventDefault(), this.hide();
          break;
        case "ArrowDown":
          e.preventDefault(), this.highlightedIndex = Math.min(
            this.highlightedIndex + 1,
            t.length - 1
          );
          break;
        case "ArrowUp":
          e.preventDefault(), this.highlightedIndex = Math.max(this.highlightedIndex - 1, 0);
          break;
        case "Enter":
        case " ":
          if (e.preventDefault(), this.highlightedIndex >= 0) {
            const i = t[this.highlightedIndex];
            i && !i.children && this.selectItem(i);
          }
          break;
      }
    };
  }
  connectedCallback() {
    super.connectedCallback(), document.addEventListener("click", this.handleOutsideClick), document.addEventListener("contextmenu", this.handleOutsideContextMenu), document.addEventListener("keydown", this.handleKeydown);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), document.removeEventListener("click", this.handleOutsideClick), document.removeEventListener("contextmenu", this.handleOutsideContextMenu), document.removeEventListener("keydown", this.handleKeydown);
  }
  /** Show the context menu at a specific position */
  show(e, t) {
    this.position = this.adjustPosition(e, t), this.open = !0, this.highlightedIndex = -1, c(this, u.OPEN);
  }
  /** Hide the context menu */
  hide() {
    this.open = !1, this.highlightedIndex = -1, c(this, u.CLOSE);
  }
  adjustPosition(e, t) {
    const n = this.items.length * 36, o = window.innerWidth, a = window.innerHeight;
    return e + 200 > o && (e = o - 200 - 8), t + n > a && (t = a - n - 8), { x: Math.max(8, e), y: Math.max(8, t) };
  }
  selectItem(e) {
    e.disabled || e.divider || (c(this, u.SELECT, { item: e, id: e.id }), this.hide());
  }
  renderItem(e, t) {
    if (e.divider)
      return r`<div part="divider" class="divider"></div>`;
    const i = e.children && e.children.length > 0, n = {
      item: !0,
      disabled: e.disabled ?? !1,
      danger: e.danger ?? !1,
      highlighted: t === this.highlightedIndex,
      "item-with-submenu": !!i
    }, o = r`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="m9 18 6-6-6-6"/>
      </svg>
    `;
    return r`
      <div
        part="item"
        class=${v(n)}
        role="menuitem"
        tabindex=${e.disabled ? -1 : 0}
        aria-disabled=${e.disabled ?? !1}
        @click=${() => !i && this.selectItem(e)}
        @mouseenter=${() => this.highlightedIndex = t}
      >
        ${e.icon ? r`<span part="icon" class="icon">${this.renderIcon(e.icon)}</span>` : h}

        <span part="label" class="label">${e.label}</span>

        ${e.shortcut ? r`<span part="shortcut" class="shortcut">${e.shortcut}</span>` : h}

        ${i ? r`
              <span part="submenu-arrow" class="submenu-arrow">${o}</span>
              <div class="submenu" role="menu">
                ${e.children.map((a, d) => this.renderItem(a, d))}
              </div>
            ` : h}
      </div>
    `;
  }
  renderIcon(e) {
    return {
      copy: r`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect width="14" height="14" x="8" y="8" rx="2" ry="2"/><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"/></svg>`,
      cut: r`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="6" cy="6" r="3"/><path d="M8.12 8.12 12 12"/><path d="M20 4 8.12 15.88"/><circle cx="6" cy="18" r="3"/><path d="M14.8 14.8 20 20"/></svg>`,
      paste: r`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect width="8" height="4" x="8" y="2" rx="1" ry="1"/><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/></svg>`,
      delete: r`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/></svg>`,
      edit: r`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z"/></svg>`,
      download: r`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" x2="12" y1="15" y2="3"/></svg>`,
      share: r`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" x2="15.42" y1="13.51" y2="17.49"/><line x1="15.41" x2="8.59" y1="6.51" y2="10.49"/></svg>`,
      refresh: r`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"/><path d="M21 3v5h-5"/><path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"/><path d="M8 16H3v5"/></svg>`,
      settings: r`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"/><circle cx="12" cy="12" r="3"/></svg>`,
      folder: r`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z"/></svg>`,
      file: r`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"/><path d="M14 2v4a2 2 0 0 0 2 2h4"/></svg>`
    }[e] || h;
  }
  render() {
    const e = {
      menu: !0,
      open: this.open
    }, t = {
      left: `${this.position.x}px`,
      top: `${this.position.y}px`
    };
    return r`
      <div
        class="trigger"
        @contextmenu=${this.handleContextMenu}
      >
        <slot></slot>
      </div>

      <div
        part="menu"
        id=${this.menuId}
        class=${v(e)}
        style=${b(t)}
        role="menu"
        aria-hidden=${!this.open}
      >
        ${this.items.map((i, n) => this.renderItem(i, n))}
      </div>
    `;
  }
};
s.styles = [
  k,
  m`
      :host {
        display: contents;
      }

      *,
      *::before,
      *::after {
        box-sizing: border-box;
      }

      .trigger {
        display: contents;
      }

      .menu {
        position: fixed;
        z-index: var(--r5-z-dropdown);
        min-width: 12rem;
        max-width: 20rem;
        background-color: var(--r5-surface);
        border: 1px solid var(--r5-border);
        border-radius: var(--r5-radius-lg);
        box-shadow: var(--r5-shadow-popover, var(--r5-shadow-lg));
        padding: var(--r5-space-1);
        opacity: 0;
        visibility: hidden;
        transform: scale(0.95);
        transform-origin: top left;
        transition: all var(--r5-duration-fast) var(--r5-ease-out);
        font-family: var(--r5-font-body);
        font-size: var(--r5-text-sm);
      }

      .menu.open {
        opacity: 1;
        visibility: visible;
        transform: scale(1);
      }

      .item {
        display: flex;
        align-items: center;
        gap: var(--r5-space-2);
        padding: var(--r5-space-2) var(--r5-space-3);
        border-radius: var(--r5-radius-md);
        cursor: pointer;
        color: var(--r5-text);
        transition: background-color var(--r5-duration-fast) var(--r5-ease-default);
        position: relative;
      }

      .item:hover,
      .item.highlighted {
        background-color: var(--r5-bg-muted);
      }

      .item:focus-visible {
        outline: var(--r5-focus-ring-width) solid var(--r5-focus-ring-color);
        outline-offset: -2px;
      }

      .item.disabled {
        opacity: 0.5;
        cursor: not-allowed;
        pointer-events: none;
      }

      .item.danger {
        color: var(--r5-color-danger-600);
      }

      .item.danger:hover,
      .item.danger.highlighted {
        background-color: var(--r5-color-danger-50);
      }

      .icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 1rem;
        height: 1rem;
        color: var(--r5-text-muted);
      }

      .item.danger .icon {
        color: inherit;
      }

      .icon svg {
        width: 100%;
        height: 100%;
      }

      .label {
        flex: 1;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .shortcut {
        font-size: var(--r5-text-xs);
        color: var(--r5-text-muted);
        margin-left: auto;
        padding-left: var(--r5-space-4);
      }

      .submenu-arrow {
        width: 1rem;
        height: 1rem;
        color: var(--r5-text-muted);
        margin-left: auto;
      }

      .submenu-arrow svg {
        width: 100%;
        height: 100%;
      }

      .divider {
        height: 1px;
        background-color: var(--r5-border);
        margin: var(--r5-space-1) var(--r5-space-2);
      }

      /* Submenu */
      .item-with-submenu {
        position: relative;
      }

      .submenu {
        position: absolute;
        left: 100%;
        top: 0;
        margin-left: var(--r5-space-1);
        min-width: 10rem;
        background-color: var(--r5-surface);
        border: 1px solid var(--r5-border);
        border-radius: var(--r5-radius-lg);
        box-shadow: var(--r5-shadow-popover, var(--r5-shadow-lg));
        padding: var(--r5-space-1);
        opacity: 0;
        visibility: hidden;
        transform: translateX(-4px);
        transition: all var(--r5-duration-fast) var(--r5-ease-out);
      }

      .item-with-submenu:hover .submenu,
      .item-with-submenu:focus-within .submenu {
        opacity: 1;
        visibility: visible;
        transform: translateX(0);
      }

      @media (prefers-reduced-motion: reduce) {
        .menu,
        .submenu {
          transition: none;
        }
      }
    `
];
l([
  x(".menu")
], s.prototype, "menuElement", 2);
l([
  p({ type: Array })
], s.prototype, "items", 2);
l([
  p({ type: Boolean, reflect: !0 })
], s.prototype, "open", 2);
l([
  p({ type: Boolean, reflect: !0 })
], s.prototype, "disabled", 2);
l([
  g()
], s.prototype, "position", 2);
l([
  g()
], s.prototype, "highlightedIndex", 2);
s = l([
  f("ark-context-menu")
], s);
export {
  s as A
};
//# sourceMappingURL=ark-context-menu-BjYGaoUl.js.map
